module.exports = __webpack_public_path__ + "static/img/honor_5.3d4d8b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/about/honor_5.jpg
// module id = P5LR
// module chunks = 0